let cachedAudio = null;
let unlocked = false;

const FILLED_AUDIO_SRC = "/order_placed.mp3";
const EXECUTED_AUDIO_SRC = "/order_executed.mp3";
const CLOSED_AUDIO_SRC = "/order_closed.mp3";
const CANCELLED_AUDIO_SRC = "/order_cancelled.mp3";
const ERROR_AUDIO_SRC = "/error.mp3";
const NOTIFICATION_AUDIO_SRC = "/notification.mp3";

function findAudio() {
  if (cachedAudio) return cachedAudio;

  try {
    const a = new Audio(FILLED_AUDIO_SRC);
    a.preload = "auto";
    cachedAudio = a;
    return cachedAudio;
  } catch {
    return null;
  }
}

function createAudio(src) {
  try {
    const a = new Audio(src);
    a.preload = "auto";
    return a;
  } catch {
    return null;
  }
}

export function ensureUnlocked() {
  if (typeof window === "undefined" || unlocked) return;

  const handler = () => {
    try {
      const a = findAudio();
      if (!a) return;

      const p = a.play();
      if (p && typeof p.then === "function") {
        p.then(() => {
          a.pause();
          a.currentTime = 0;
          unlocked = true;
          remove();
        }).catch(() => {});
      } else {
        a.pause();
        a.currentTime = 0;
        unlocked = true;
        remove();
      }
    } catch {}
  };

  const remove = () => {
    window.removeEventListener("pointerdown", handler);
    window.removeEventListener("touchstart", handler);
    window.removeEventListener("keydown", handler);
    window.removeEventListener("click", handler);
  };

  window.addEventListener("pointerdown", handler, { once: false });
  window.addEventListener("touchstart", handler, { once: false });
  window.addEventListener("keydown", handler, { once: false });
  window.addEventListener("click", handler, { once: false });
}

export async function playOrderFilled() {
  try {
    const a = findAudio();
    if (!a) return false;

    if (!unlocked) ensureUnlocked();

    a.currentTime = 0;
    await a.play();
    return true;
  } catch {
    return false;
  }
}

export async function playOrderClosed() {
  try {
    const a = createAudio(CLOSED_AUDIO_SRC);
    if (!a) return false;
    if (!unlocked) ensureUnlocked();
    a.currentTime = 0;
    await a.play();
    return true;
  } catch {
    return false;
  }
}

export async function playError() {
  try {
    const a = createAudio(ERROR_AUDIO_SRC);
    if (!a) return false;
    if (!unlocked) ensureUnlocked();
    a.currentTime = 0;
    await a.play();
    return true;
  } catch {
    return false;
  }
}

export async function playNotification() {
  try {
    const a = createAudio(NOTIFICATION_AUDIO_SRC);
    if (!a) return false;
    if (!unlocked) ensureUnlocked();
    a.currentTime = 0;
    await a.play();
    return true;
  } catch {
    return false;
  }
}

export async function playOrderExecuted() {
  try {
    const a = createAudio(EXECUTED_AUDIO_SRC);
    if (!a) return false;
    if (!unlocked) ensureUnlocked();
    a.currentTime = 0;
    await a.play();
    return true;
  } catch {
    return false;
  }
}

export async function playOrderCancelled() {
  try {
    const a = createAudio(CANCELLED_AUDIO_SRC);
    if (!a) return false;
    if (!unlocked) ensureUnlocked();
    a.currentTime = 0;
    await a.play();
    return true;
  } catch {
    return false;
  }
}

if (typeof window !== "undefined") {
  ensureUnlocked();
}
